
import http from "@/http"

export default {
    namespaced: true,

    state () {
        return {
            all: []
        }
    },

    mutations: {
        setAll (state, data) {
            state.all = data
        }
    },

    actions: {
        getAvailable ({ commit }, { state }) {
            return http(`/api/coverages/available?state=${state}`).then(response => {
                if (!response.data.error) {
                    commit("setAll", response.data)
                }

                return response
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/coverages.js